
'use strict';

define('composer/online-video', ['quill'], (Quill) => {
	const BlockEmbed = Quill.import('blots/block/embed');

	class OnlineVideo extends BlockEmbed {
		static create(params) {
			const p = params || {};
			if (!p.src) {
				throw new Error('[composer/online-video] params should have src content.');
			}
			const node = super.create();
			if (p.id) {
				node.id = 'ql-online-video__' + p.id;
				node.setAttribute('data-id', p.id);
			}
			node.className = 'iframely-container';
			node.innerHTML = `<div class="iframely-container__inner"><iframe class="ql-video" src="${p.src}" frameborder="0" allowfullscreen></iframe></div>`;
			return node;
		}

		static value(domNode) {
			const iframe = domNode.querySelector('iframe');

			if (iframe) {
				return {
					id: domNode.getAttribute('data-id') || '',
					src: iframe.getAttribute('src'),
				};
			}

			return null;
		}
	}


	OnlineVideo.blotName = 'OnlineVideo';
	OnlineVideo.tagName = 'div';

	return OnlineVideo;
});
